import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import Seo from '../../components/common/Seo';

export default function OrderConfirmation() {
  const { search } = useLocation();
  const [status, setStatus] = useState('pending');

  useEffect(() => {
    const params = new URLSearchParams(search);
    const reference = params.get('reference');
    if (!reference) return;
    const verify = async () => {
      const res = await fetch(`/api/checkout/verify?reference=${reference}`);
      if (res.ok) {
        const data = await res.json();
        setStatus(data.status || 'pending');
      } else {
        setStatus('failed');
      }
    };
    verify();
  }, [search]);

  return (
    <div className="min-h-screen bg-[#021206] text-white">
      <Seo
        title="Order Confirmation"
        description="Confirm your GameMeetsWorld store order payment status."
        path="/order-confirmation"
        noIndex
      />
      <Navbar mobileMenuOpen={false} setMobileMenuOpen={() => {}} />
      <main className="pt-32 pb-20 max-w-3xl mx-auto px-6">
        <h1 className="text-4xl font-bold mb-4">Order Confirmation</h1>
        <p className="text-white/70 mb-6">
          {status === 'success' || status === 'paid'
            ? 'Payment successful. Your order is confirmed!'
            : status === 'pending'
              ? 'Your payment is being verified.'
              : 'Payment verification failed. Please contact support.'}
        </p>
        <div className="bg-[#0A0E11] border border-white/10 rounded-xl p-6">
          <p className="text-sm text-white/60">Status</p>
          <p className="text-2xl font-bold mt-2">{status}</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
